<template>
  <div class="product-list-wrap">
    <div
      v-for="(item, idx) in products"
      :key="item.baseItemId"
      :class="['product-list-item', errorMap[item.baseItemId] || errorImgsMap[item.baseItemId] ? 'error-item' : '', idx === activeIndex ? 'active' : '']"
      @click="selectProduct(idx, item.baseItemId)"
    >
      <!-- 图标区 -->
      <div class="item-status-icon">
        <div class="status-content">
          <el-tooltip v-if="errorMap[item.baseItemId] || errorImgsMap[item.baseItemId]" content="必填项待完善" placement="top">
            <i class="el-icon-warning" style="color: #f4970a" />
          </el-tooltip>
          <i v-else style="color: #fff" class="el-icon-check"></i>
        </div>
      </div>
      <div class="item-index">{{ idx + 1 }}</div>
      <img class="item-img" :src="item.picUrl && item.picUrl.length ? item.picUrl[0] : defaultImg" alt="" />
      <div class="item-title" :title="item.goodsName">{{ item.goodsName }}</div>
      <div class="del-btn" @click.stop="deleteProduct(item.baseItemId)"><i class="el-icon-close" /></div>
    </div>
    <el-button v-if="products.length < 50" class="add-btn" type="primary" icon="el-icon-plus" @click="addProduct"> 添加更多商品 </el-button>
  </div>
</template>

<script>
export default {
  name: 'ProductList',
  props: {
    products: Array,
    errorMap: Object,
    errorImgsMap: Object,
    activeIndex: Number,
  },
  data() {
    return {
      defaultImg: '',
    };
  },
  methods: {
    selectProduct(idx, baseItemId) {
      this.$emit('select', idx, baseItemId);
    },
    addProduct() {
      this.$emit('add');
    },
    deleteProduct(baseItemId) {
      this.$emit('delete', baseItemId);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-list-wrap {
  width: 260px;
  background: #f8f9fa;
  padding: 16px 8px;
  border-radius: 4px;
  min-height: 400px;
}
.product-list-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 6px;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 8px;
  background: #fff;
  border: 1px solid transparent;
  transition: border 0.2s;
  &:hover {
    .del-btn {
      display: flex;
    }
  }
  .item-status-icon {
    position: absolute;
    left: 0px;
    top: 0px;
    border-bottom: 30px solid transparent;
    border-right: 30px solid transparent;
    border-top: 20px solid #3498db; /* 蓝色三角 */
    .status-content {
      position: absolute;
      font-size: 12px;
      top: -23px;
      left: 2px;
      font-weight: 700;
    }
  }
}
.error-item {
  border: 1.5px solid #e91519;
  color: #e91519;
}
.product-list-item.active {
  border: 1.5px solid #409eff;
  background: #eaf4ff;
  color: #409eff;
}
.item-index {
  width: 20px;
  color: #409eff;
  font-weight: bold;
  margin-right: 6px;
}
.item-img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 2px;
  margin-right: 8px;
  background: #eee;
}
.item-title {
  flex: 1;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.add-btn {
  width: 100%;
  margin-top: 12px;
}
.del-btn {
  cursor: pointer;
  display: none;
  position: absolute;
  color: #fff;
  font-size: 12px;
  background-color: rgba(0, 0, 0, 0.3);
  justify-content: center;
  align-items: center;
}
.del-btn {
  width: 18px;
  height: 18px;
  top: 0;
  right: 0;
  border-radius: 50%;
  transform: translate(45%, -45%);
}
</style> 